import { RefundActions } from './../actions/refund.actions';
import { tassign } from 'tassign';
import { RidangoReduxAction, RefundableTicket, RefundMethodInterface, RefundMethodWallet, RefundMethodBanklink } from '@ridango/core';




export interface RefundState {
    all: RefundableTicket[];
    docNums: number[];
    nonRefundableDocNums: number[];
    normalized: any;
    selectedDocNums: number[];
    totalSum: number;
    refundMethods: any[];
    selectedRefundMethod: any;
    selectedRefundMethodValid: boolean;
    progress: number;
    agreement: boolean;
    availableCards: number[];
    refundedCart: any;
    nonRefundedTickets: RefundableTicket[];
    fee: number;
}
export const REFUND_INITIAL_STATE: RefundState = {
    all: [],
    docNums: [],
    nonRefundableDocNums: [],
    normalized: {},
    selectedDocNums: [],
    totalSum: 0,
    refundMethods: [
        new RefundMethodWallet( 'WALLET', 'LOCAL_REFUND_TYPE_NAME_WALLET' ),
        new RefundMethodBanklink( 'BANKLINK', 'LOCAL_REFUND_TYPE_NAME_BANKLINK' ),
    ],
    selectedRefundMethod: null,
    selectedRefundMethodValid: false,
    progress: 0,
    agreement: false,
    availableCards: [],
    refundedCart: null,
    nonRefundedTickets: [],
    fee: 0

};

export function refundReducer ( lastState: RefundState = REFUND_INITIAL_STATE, action: RidangoReduxAction ): RefundState {
    switch ( action.type ) {
        case RefundActions.SET_REFUNDABLE_TICKETS_DATA:
            return tassign( lastState, {
                all: action.payload.all,
                docNums: action.payload.docNums,
                nonRefundableDocNums: action.payload.nonRefundableDocNums,
                normalized: action.payload.normalized,
                progress: 1,
                availableCards: action.payload.cards
            } );
        case RefundActions.TOGGLE_SELECTED_REFUNDABLE_TICKET:
            let selectedNums = [];
            let total = 0;
            let progress = 1;
            let remove = false;
            if ( lastState.selectedDocNums.indexOf( action.payload.doc_num ) >= 0 ) {
                selectedNums = [ ...lastState.selectedDocNums.slice( 0, lastState.selectedDocNums.indexOf( action.payload.doc_num ) ),
                ...lastState.selectedDocNums.slice( lastState.selectedDocNums.indexOf( action.payload.doc_num ) + 1 ) ];
                remove = true;
            } else {
                selectedNums = [ ...lastState.selectedDocNums, action.payload.doc_num ];
                remove = false;
            }
            total = selectedNums.reduce( ( acc, val ) => ( ( acc * 100 ) + ( lastState.normalized[ val ].price * 100 ) ) / 100, 0 );
            if ( selectedNums.length > 0 ) {
                if ( selectedNums.length === 1 && !remove ) {
                    progress = 2;
                    return tassign( lastState, {
                        selectedDocNums: selectedNums,
                        totalSum: total,
                        progress: progress,
                    } );
                } else {
                    return tassign( lastState, {
                        selectedDocNums: selectedNums,
                        totalSum: total,
                    } );
                }
            } else {
                progress = 1;
            }
            return tassign( lastState, {
                selectedDocNums: selectedNums,
                totalSum: total,
                progress: progress,
                selectedRefundMethod: null
            } );
        case RefundActions.SET_SELECTED_REFUND_METHOD:
            return tassign( lastState, {
                selectedRefundMethod: action.payload,
                selectedRefundMethodValid: false,
                agreement: false,
                progress: 3
            } );
        case RefundActions.SET_REFUND_PROGRESS:
            return tassign( lastState, {
                progress: action.payload
            } );
        case RefundActions.INCREASE_REFUND_PROGRESS:
            return tassign( lastState, {
                progress: lastState.progress + 1
            } );
        case RefundActions.DECREASE_REFUND_PROGRESS:
            return tassign( lastState, {
                progress: lastState.progress - 1
            } );
        case RefundActions.RESET_REFUNDABLE_TICKETS_DATA:
            return tassign( lastState, REFUND_INITIAL_STATE );
        case RefundActions.SET_SELECTED_METHOD_DATA:
            // remove empty object properties to prevent current data from being overwritten
            const refundData = Object.entries(action.payload).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {});
            return tassign( lastState, {
                selectedRefundMethod: { ...lastState.selectedRefundMethod, ...refundData },
                selectedRefundMethodValid: true,
                progress: 4
            } );
        case RefundActions.SET_SELECTED_METHOD_CARD_NUMBER:
            return tassign( lastState, {
                selectedRefundMethod: { ...lastState.selectedRefundMethod, card_id: action.payload },
                selectedRefundMethodValid: true,
                progress: 4
            } );
        case RefundActions.SET_AGREEMENT:
            return tassign( lastState, {
                agreement: action.payload
            } );

        case RefundActions.SET_AVAILABLE_CARDS:
            return tassign( lastState, {
                availableCards: action.payload
            } );
        case RefundActions.SET_SELECTED_REFUND_METHOD_VALIDITY:
            return tassign( lastState, {
                selectedRefundMethodValid: action.payload
            } );
        case RefundActions.SET_REFUND_RESULT:
            return tassign( lastState, {
                all: [],
                docNums: [],
                nonRefundableDocNums: [],
                normalized: {},
                selectedDocNums: [],
                totalSum: 0,
                refundMethods: [
                    new RefundMethodWallet( 'WALLET', 'LOCAL_REFUND_TYPE_NAME_WALLET' ),
                    new RefundMethodBanklink( 'BANKLINK', 'LOCAL_REFUND_TYPE_NAME_BANKLINK' ),
                ],
                selectedRefundMethod: lastState.selectedRefundMethod,
                selectedRefundMethodValid: false,
                progress: 0,
                agreement: false,
                availableCards: [],
                refundedCart: action.payload.cart,
                nonRefundedTickets: action.payload.nonRefunded
            } );


        case RefundActions.SET_REFUND_FEE:
            return tassign( lastState, {
                fee: action.payload
            } );

    }
    return lastState;
}
